import React, { useState } from "react";
import { X, Eye } from "lucide-react";
import { Section, Reveal, Eyebrow } from "@/components/primitives";

const showroom = [
  { name: "Pasticceria Dolce Vita", category: "Sito Web · Ristorazione", img: "https://static.prod-images.emergentagent.com/jobs/604facf5-ed56-4c6c-ac5b-7b5b577005ba/images/ec3fc5bb29b6a0183051d8d9a2bd7954c66bf0c8190f3362806fd1f74e09e5ce.png" },
  { name: "Bianchi Costruzioni", category: "Sito Web · Aziendale", img: "https://static.prod-images.emergentagent.com/jobs/604facf5-ed56-4c6c-ac5b-7b5b577005ba/images/8b039081f69887cf08fd12a8c5b7d86f83961211cc2a132917f0209c9d97600a.png" },
  { name: "Studio Conti · Commercialista", category: "Sito Web · Professionisti", img: "https://static.prod-images.emergentagent.com/jobs/604facf5-ed56-4c6c-ac5b-7b5b577005ba/images/73c04e1d9e5db2e5f114e1578c06a1f090376ab225d39baad2ea1f35fb7f3306.png" },
  { name: "Trattoria Il Borgo", category: "Sito Web · Ristorazione", img: "https://static.prod-images.emergentagent.com/jobs/604facf5-ed56-4c6c-ac5b-7b5b577005ba/images/1e2c9a6ea881ca450e883f3364595c51ece3eba34fcac729c536c5ac9565651a.png" },
  { name: "Salone Bellezza", category: "Sito Web · Beauty", img: "https://static.prod-images.emergentagent.com/jobs/604facf5-ed56-4c6c-ac5b-7b5b577005ba/images/009c74f487933d60046a50648172574290ba39a58d603863480a464b3a16e6c5.png" },
  { name: "PowerFit Club", category: "Sito Web · Fitness", img: "https://static.prod-images.emergentagent.com/jobs/604facf5-ed56-4c6c-ac5b-7b5b577005ba/images/9897b6331ae7251a5f32bf5122d8b7fc9277aa399681015e0bb10ad3c680790c.png" },
  { name: "Studio Dentistico Sorriso", category: "Sito Web · Medico", img: "https://static.prod-images.emergentagent.com/jobs/604facf5-ed56-4c6c-ac5b-7b5b577005ba/images/fd6f6609128ac7938d9ecc277b1eca23fe00d08afb2c03b1bef195395e3e6864.png" },
  { name: "Atelier Moda", category: "E-commerce · Moda", img: "https://static.prod-images.emergentagent.com/jobs/604facf5-ed56-4c6c-ac5b-7b5b577005ba/images/224b661085f6d772e1291b122b9e3bba0e0d39d5c680c2402165e54ed30da5b0.png" },
  { name: "Casa Verde B&B", category: "Sito Web · Turismo", img: "https://static.prod-images.emergentagent.com/jobs/604facf5-ed56-4c6c-ac5b-7b5b577005ba/images/b8cb0db0c1bf6bf9c082f0c744332252bac4e620f886170fb053b14c5dc92222.png" },
  { name: "Autofficina Rossi", category: "Sito Web · Automotive", img: "https://static.prod-images.emergentagent.com/jobs/604facf5-ed56-4c6c-ac5b-7b5b577005ba/images/72f2ec9b75558825428441dbac9a074d73031d3d2971fb01d07d1e4d3a866089.png" },
];

const BrowserFrame = ({ children, onClick, testid }) => (
  <button
    onClick={onClick}
    data-testid={testid}
    className="group/card block text-left rounded-2xl overflow-hidden bg-white shadow-[0_8px_30px_rgba(0,0,0,0.08)] hover:shadow-[0_16px_50px_rgba(0,0,0,0.16)] hover:-translate-y-1.5 transition-all duration-300 w-[300px] sm:w-[380px] shrink-0"
  >
    <div className="flex items-center gap-1.5 px-4 py-3 bg-[#12131A]">
      <span className="h-2.5 w-2.5 rounded-full bg-[#FF5F57]" />
      <span className="h-2.5 w-2.5 rounded-full bg-[#FEBC2E]" />
      <span className="h-2.5 w-2.5 rounded-full bg-[#28C840]" />
      <span className="ml-3 flex-1 h-5 rounded bg-white/10" />
    </div>
    {children}
  </button>
);

export default function ShowroomCarousel() {
  const [selected, setSelected] = useState(null);
  const loop = [...showroom, ...showroom];

  return (
    <Section className="pt-6 pb-16" id="showroom">
      <Reveal>
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <Eyebrow>Showroom</Eyebrow>
            <h2 className="mt-4 font-display font-bold text-3xl lg:text-4xl tracking-tight text-ink">
              Una vetrina dei siti che realizziamo.
            </h2>
          </div>
          <p className="text-ink/50 text-sm max-w-xs">
            Passa il mouse per fermare lo scorrimento. Clicca su un sito per vederne l'anteprima.
          </p>
        </div>
      </Reveal>

      <div
        className="marquee-group mt-12 relative overflow-hidden"
        data-testid="showroom-carousel"
      >
        {/* fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 z-10 bg-gradient-to-r from-beige to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 z-10 bg-gradient-to-l from-beige to-transparent" />

        <div className="flex gap-6 animate-marquee py-2">
          {loop.map((s, i) => (
            <BrowserFrame
              key={i}
              testid={`showroom-card-${i}`}
              onClick={() => setSelected(s)}
            >
              <div className="relative">
                <img
                  src={s.img}
                  alt={s.name}
                  loading="lazy"
                  className="w-full h-[230px] object-cover object-top"
                />
                <div className="absolute inset-0 bg-ink/0 group-hover/card:bg-ink/40 transition-colors duration-300 flex items-center justify-center">
                  <span className="opacity-0 group-hover/card:opacity-100 transition-opacity duration-300 inline-flex items-center gap-2 bg-white text-ink rounded-full px-5 py-2.5 text-sm font-semibold">
                    <Eye size={16} /> Anteprima
                  </span>
                </div>
              </div>
              <div className="px-5 py-4">
                <div className="font-display font-bold text-ink">{s.name}</div>
                <div className="text-xs uppercase tracking-widest text-coral mt-1">{s.category}</div>
              </div>
            </BrowserFrame>
          ))}
        </div>
      </div>

      {/* Lightbox preview (image only, no external link) */}
      {selected && (
        <div
          className="fixed inset-0 z-[9999] bg-ink/80 backdrop-blur-sm flex items-center justify-center p-4 sm:p-8"
          onClick={() => setSelected(null)}
          data-testid="showroom-lightbox"
        >
          <div
            className="relative w-full max-w-4xl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelected(null)}
              data-testid="showroom-lightbox-close"
              className="absolute -top-12 right-0 text-beige hover:text-coral transition-colors flex items-center gap-2 text-sm font-medium"
            >
              Chiudi <X size={22} />
            </button>
            <div className="rounded-2xl overflow-hidden bg-white shadow-2xl">
              <div className="flex items-center gap-1.5 px-4 py-3 bg-[#12131A]">
                <span className="h-3 w-3 rounded-full bg-[#FF5F57]" />
                <span className="h-3 w-3 rounded-full bg-[#FEBC2E]" />
                <span className="h-3 w-3 rounded-full bg-[#28C840]" />
                <span className="ml-3 flex-1 h-6 rounded bg-white/10" />
              </div>
              <img src={selected.img} alt={selected.name} className="w-full max-h-[70vh] object-contain bg-white" />
              <div className="px-6 py-4 flex items-center justify-between">
                <div>
                  <div className="font-display font-bold text-lg text-ink">{selected.name}</div>
                  <div className="text-xs uppercase tracking-widest text-coral mt-0.5">{selected.category}</div>
                </div>
                <span className="text-xs text-ink/40">Anteprima dimostrativa</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </Section>
  );
}
